import { Pipe, PipeTransform } from '@angular/core';
import {QuantityForOneProduct} from '@states';

@Pipe({
  name: 'quantityText'
})
export class QuantityTextPipe implements PipeTransform {

  transform(value: QuantityForOneProduct): string[] {
    const result: string[] = [];
    result.push(Math.trunc(value.balanceNum).toFixed(0));
    result.push(((value.balanceNum - Math.trunc(value.balanceNum)) * value.packageContentNum).toFixed(0));
    return result;
  }

}
